__turbopack_context__.v({
  "actionButton": "Modal-module-scss-module__k1ZY8q__actionButton",
  "modalBackground": "Modal-module-scss-module__k1ZY8q__modalBackground",
  "modalContainer": "Modal-module-scss-module__k1ZY8q__modalContainer",
  "modalContent": "Modal-module-scss-module__k1ZY8q__modalContent",
  "modalFooter": "Modal-module-scss-module__k1ZY8q__modalFooter",
  "modalNamespace": "Modal-module-scss-module__k1ZY8q__modalNamespace",
  "wideModal": "Modal-module-scss-module__k1ZY8q__wideModal",
});
